import {
  aLogMapping,
  aLogMappingVendorAndProduct,
  mockLogMappingDetailQueryQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockLogMappingDetailQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          logMapping: aLogMapping(),
          logMappingVendorsAndProducts: [
            aLogMappingVendorAndProduct({
              product: aLogMapping().product as string,
              vendor: aLogMapping().vendor as string,
            }),
          ],
        },
      });
    }
  ),
];
